import BookGoalGroup from "components/BookGroup/groups/BookGoalGroup";
import { GoalSerializersGoalByline, UserSerializersUserByline } from "types/serializers";

export interface Props {
  user: UserSerializersUserByline
  goals: GoalSerializersGoalByline[];
}
export default function Goals({ user, goals }: Props) {
  return (
    <div className="flex w-full">
      <div className="w-full">
        <div className="space-y-8">
          <div className="space-y-4">
            {goals.map((goal) => (
              <BookGoalGroup
                key={`goal-${goal.id}`}
                goal={goal}
                user={user}
                size="lg"
              />
            ))}
          </div>

          {goals.length === 0 ? (
            <div className="text-gray-400 ">
              <p className="mb-2">
                Reading goals are an amazing way to help motivation.
              </p>
              <p className="mb-2">Here are a few examples:</p>

              <ul className="list-disc ml-8 mb-6">
                <li>
                  Read <b>26 books</b> in <b>2021</b>.
                </li>
                <li>
                  Read <b>10,000 pages</b> in <b>2021</b>.
                </li>
                <li>
                  Read <b>6 books</b> from <b>Obama's Summer Reading List</b> by{" "}
                  <b>November 1, 2021</b>.
                </li>
                <li>
                  Listen to <b>10 books</b> by <b>women authors</b> in 2022.
                </li>
                <li>
                  Read to <b>5 books</b> by <b>LGBTQ+ authors</b> in 2022.
                </li>
              </ul>
            </div>
          ) : (
            false
          )}
        </div>
      </div>
    </div>
  );
}
